// @ts-nocheck
/* eslint-disable */
export const faInboxIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M567.403 235.642 462.323 84.589A48 48 0 0 0 422.919 64H153.081a48 48 0 0 0-39.404 20.589L8.597 235.642A48 48 0 0 0 0 263.054V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V263.054c0-9.801-3-19.366-8.597-27.412M153.081 112h269.838l77.913 112H378.334l-32 64H229.666l-32-64H75.168zM528 400H48V272h120l32 64h176l32-64h120z"/></svg>`,
    name: 'inbox' as const
};